import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { ThemeService } from '../../core/services/theme.service';
import { LayoutService } from '../../core/services/layout.service';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent],
  template: `
    <div class="shell">
      <!-- Mobile Overlay -->
      <div
        class="mobile-overlay"
        *ngIf="layout.isSidebarOpen()"
        (click)="layout.closeSidebar()"
      ></div>

      <app-sidebar></app-sidebar>
      <main class="shell-content">
        <!-- Mobile TopBar -->
        <header class="mobile-topbar">
          <button class="menu-btn" (click)="layout.toggleSidebar()" aria-label="Abrir menú">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <div class="mobile-logo">Gridxum Admin</div>
        </header>

        <div class="page-container">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  `,
  styles: [`
    .shell {
      display: flex;
      min-height: 100vh;
      background: var(--bg-app);
      position: relative;
    }
    .shell-content {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      height: 100vh;
    }
    .page-container {
      flex: 1;
      overflow: auto;
    }

    /* Mobile TopBar */
    .mobile-topbar {
      display: none;
      align-items: center;
      gap: var(--space-4);
      padding: var(--space-3) var(--space-4);
      background: var(--bg-sidebar);
      border-bottom: 1px solid var(--border-color);
      position: sticky;
      top: 0;
      z-index: 40;
    }
    .menu-btn {
      color: var(--text-on-sidebar);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: var(--radius-md);
      background: transparent;
    }
    .menu-btn:hover { background: hsla(0, 0%, 100%, 0.1); color: #fff; }
    .mobile-logo {
      font-size: var(--font-size-base);
      font-weight: var(--font-weight-bold);
      color: #fff;
    }

    .mobile-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 45;
      backdrop-filter: blur(2px);
    }

    @media (max-width: 768px) {
      .mobile-topbar { display: flex; }
      .mobile-overlay { display: block; }
    }
  `]
})
export class ShellComponent implements OnInit {
  private readonly theme = inject(ThemeService);
  readonly layout = inject(LayoutService);

  ngOnInit(): void {
    this.theme.init();
  }
}
